import react, { useContext } from "react";
import logo from "../../../assets/images/logo.png";
import { LanguageContext } from "../../../context/LanguageContext";
import udhaarCharacter from "../../../assets/images/UdhaarBook.png";
import "./styles.css";
import { HeaderRupin, InnerWrapper, MainContainer } from "../../common";
import { Box, Grid } from "@mui/material";
import styles from "./styles.module.css";
import NonIdealNew from "../../common/NonIdealNew";
import { OfflineNewIcon } from "../../../assets/icons/icon";

const Offline = () => {
  const [I18n, changeLanguage] = useContext(LanguageContext);

  const handleRefreshPage = () => {
    window.location.reload();
  };

  return (
    <MainContainer fluid className={`quickSalePage ${styles.offlineContainer}`}>
      <Grid container>
        <Grid item md={12}>
          <InnerWrapper
            className={`innerWrapper newInnerWrapper ${styles.offlineWrapper}`}
          >
            <Box className={styles.header}>
              <HeaderRupin />
            </Box>

            <NonIdealNew
              title={I18n.you_are_currently_offline}
              subtitle={
                I18n.please_check_your_internet_connection_and_try_again
              }
              button1Title="refresh"
              onButton1Click={handleRefreshPage}
              buttonOneId={"refresh_web"}
              customClassName={styles.nonIdealContainer}
              mainIcon={<OfflineNewIcon />}
            />
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default Offline;
